import Vue from 'vue'

function emphasise(el, binding){
    var expr = new RegExp(binding.value, 'ig');
    el.innerHTML = el.dataset.text.replace(
        expr,
        '<strong class="emphasis">$&</strong>'
    )
}

Vue.directive('emphasise', {
    bind(el, binding, vnode) {
        el.dataset.text = el.textContent
        // el.style.arg = binding.value.arg;
        emphasise(el, binding)
    },
    update(el, binding, vnode, oldNode){
        emphasise(el, binding)
    }
});